import { useState } from "react";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FormGroup, Label } from "reactstrap";

type YearMonthPicker = {
  selectedDate: Date | string;
  label?: string;
  name: string;
  placeholder?: string;
  classname?: string;
  onChange: (date: Date) => any;
};

const YearMonthPicker = ({
  label,
  name,
  classname,
  placeholder,
  onChange,
  selectedDate,
}: YearMonthPicker) => {
  return (
    <>
      {label && <Label className="col-form-label">{label}</Label>}
      <ReactDatePicker
        name={name}
        className={`form-control flatpickr-input ${classname}`}
        selected={selectedDate as Date}
        onChange={onChange}
        dateFormat="MM/yyyy"
        showMonthYearPicker
        calendarClassName={classname}
        placeholderText={placeholder}
      />
    </>
  );
};

export default YearMonthPicker;
